// extracted by mini-css-extract-plugin
export default {"mainContainer":"Courses_mainContainer__CAt1H","courses":"Courses_courses__4Qcwl","cardBorder":"Courses_cardBorder__fD-Hj"};